import React from 'react';
import { Link, useSearchParams, useLocation } from 'react-router-dom';
import { categories } from '../data/categories';

export default function CategoriesNavbar() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const activeCategory = searchParams.get('category') || null;

  // Determine if we're on the shop page at all
  const isShopPage = location.pathname === '/shop';

  const baseClass =
    'cursor-target relative text-[11px] lg:text-[12px] font-bold uppercase tracking-wider whitespace-nowrap transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900 rounded-sm pb-1 px-1';

  const activeClass = 'text-white after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-red-500 after:rounded-full';
  const inactiveClass = 'text-gray-300 hover:text-white';

  const isActive = (id) => isShopPage && (activeCategory === id || (id === 'all' && (activeCategory === 'all' || activeCategory === null)));

  return (
    <div className="bg-gray-900 overflow-x-auto no-scrollbar shadow-inner">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
        <nav className="flex items-center space-x-4 lg:space-x-5 py-2.5 min-w-max" aria-label="Product categories">
          <Link
            to="/shop?category=all"
            className={`${baseClass} border-r border-gray-700 pr-4 lg:pr-5 ${isActive('all') ? activeClass : inactiveClass}`}
          >
            All Parts
          </Link>
          {categories.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/shop?category=${cat.id}`}
              className={`${baseClass} ${index !== categories.length - 1 ? 'border-r border-gray-700 pr-4 lg:pr-5' : ''} ${isActive(cat.id) ? activeClass : inactiveClass}`}
            >
              {cat.name}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
}

